module.exports = __webpack_public_path__ + "static/media/LeadProjectImg.adfb105f.png";